import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect } from "react";
import Header from "../header/header";
import HeaderImageSection from "../shared/headerImageSection";
import FooterComponent from "../footerComponent/footerComponent";
import "./successstories.scss";

const SuccessStories = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <HeaderImageSection />
      <section className="desktopView p-4 container bg-white mt-4">
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead className="tableHeader">
              <TableRow>
                <TableCell className="text-white">Groom ID</TableCell>
                <TableCell className="text-white">
                  Marriage of this Groom
                </TableCell>
                <TableCell className="text-white">Bride ID</TableCell>
                <TableCell className="text-white">
                  Settled with this Bride
                </TableCell>
              </TableRow>
            </TableHead>
            {/* <TableBody className="tableBody">
              <TableRow>
                <TableCell>KG98763</TableCell>
                <TableCell>Rahul Godse</TableCell>
                <TableCell>MB75788</TableCell>
                <TableCell>Shweta Patil</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>KG98763</TableCell>
                <TableCell>Rahul Godse</TableCell>
                <TableCell>MB75788</TableCell>
                <TableCell>Shweta Patil</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>KG98763</TableCell>
                <TableCell>Rahul Godse</TableCell>
                <TableCell>MB75788</TableCell>
                <TableCell>Shweta Patil</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>KG98763</TableCell>
                <TableCell>Rahul Godse</TableCell>
                <TableCell>MB75788</TableCell>
                <TableCell>Shweta Patil</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>KG98763</TableCell>
                <TableCell>Rahul Godse</TableCell>
                <TableCell>MB75788</TableCell>
                <TableCell>Shweta Patil</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>KG98763</TableCell>
                <TableCell>Rahul Godse</TableCell>
                <TableCell>MB75788</TableCell>
                <TableCell>Shweta Patil</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>KG98763</TableCell>
                <TableCell>Rahul Godse</TableCell>
                <TableCell>MB75788</TableCell>
                <TableCell>Shweta Patil</TableCell>
              </TableRow>
            </TableBody> */}
          </Table>
        </TableContainer>
      </section>
      <section className="phoneView bg-white mt-4">
        <label className="headerLabel pl-3 mb-3">Success Stories</label>
        <div className="row">
          <div className="col">
            <div className="namesContainer">
              <div className="groom mb-4">
                <label className="id">KB76765</label>
                <label className="name">Rahul Godse</label>
              </div>
              <div className="bride">
                <label className="id">MB76765</label>
                <label className="name">Shewta Patil</label>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="namesContainer">
              <div className="groom mb-4">
                <label className="id">KB76765</label>
                <label className="name">Rahul Godse</label>
              </div>
              <div className="bride">
                <label className="id">MB76765</label>
                <label className="name">Shewta Patil</label>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="namesContainer">
              <div className="groom mb-4">
                <label className="id">KB76765</label>
                <label className="name">Rahul Godse</label>
              </div>
              <div className="bride">
                <label className="id">MB76765</label>
                <label className="name">Shewta Patil</label>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="namesContainer">
              <div className="groom mb-4">
                <label className="id">KB76765</label>
                <label className="name">Rahul Godse</label>
              </div>
              <div className="bride">
                <label className="id">MB76765</label>
                <label className="name">Shewta Patil</label>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterComponent />
    </>
  );
};
export default SuccessStories;
